export default "/packs/images/yoga~406f1031873acc29ce24ac85f39919de.jpg";